module.exports = __webpack_public_path__ + "static/media/error.a5c42f70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/error.svg
// module id = 2492
// module chunks = 0